export default {
  historico: state => state.historico
};
